<mat-toolbar class="z-10 shadow background-colorr">
    <div class="flex flex-row w-full h-full">
        <div class="w-1/3 flex justify-center md:justify-start items-center">
            <img class="w-16 m-4" [src]="logoImage" alt="" />
        </div>
        <div class="w-1/3 flex justify-center items-center">
        </div>
    </div>
    <div class="flex justify-end w-full md:w-2/4 py-8">
        <select
            class="block appearance-none bg-white border border-gray-300 hover:border-gray-400 px-2 py-1 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
            (change)="changeLanguage($event.target.value)" [value]="currentLang">
            <option value="eng">English</option>
            <option value="esp">Español</option>
        </select>
    </div>
</mat-toolbar>

<div *ngIf="!isFormAlreadySubmitted && isTokenValid && questionaire" class="md:px-16 md:mt-3">
    <form #myForm="ngForm" (ngSubmit)="sendQuestionnaire(myForm)" class="my-form pt-2">
        <!--Esta sección es para el nuevo candidato -->
        <div>
            <div class="custom-max-width mx-auto flex flex-col">
                <div class="text-center w-full green-title">{{"candidateCFTitle" | translate}}</div>
                <div [innerHTML]="'candidateCFMessage' | translate:{ company: companyNameNormal, candidateName: candidateName }"
                    class="text-left pl-5 w-full gray-subtitle pt-4 pb-4"></div>

                <!-- Cuestionario filtro -->
                <div class="flex flex-col py-3 w-full px-6 wizard-container mb-4">
                    <div class="flex justify-between items-center py-1.5 text-xl wizard-header"
                        (click)="toggleWizardContainerQuestionnaire()" (keydown)="handleKeydownQuestionnaire($event)"
                        tabindex="1">
                        <div class="dropdown-title pl-2">
                            {{ questionaire.questionnairE_NAME }}
                        </div>
                        <button type="button">
                            <img [src]="expandIcon" alt=""
                                [ngClass]="{'rotate-180': isWizardContainerExpandedQuestionnaire}">
                        </button>
                    </div>
                    <div *ngIf="isWizardContainerExpandedQuestionnaire" class="flex flex-col md:flex-row flex-wrap p-4">
                        <div class="flex flex-col mb-2 gap-1 w-full">
                            <div class="w-full gray-subtitle text-xs text-wrap whitespace-pre-wrap">
                                {{ questionaire.questionnairE_DESCRIPTION }}
                            </div>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full gap-3 items-end">
                            <div *ngFor="let question of questionaire.questions; let i = index" class="w-full">
                                <label class="title-input-text">
                                    {{ question.questioN_TEXT }}*
                                </label>
                                <div *ngIf="question.questioN_TYPE == 'OPEN_ENDED'"
                                    class="input-container mobile-responsive">
                                    <input [id]="'questionFormQuest' + i" type="text" class="custom-input2"
                                        [tabIndex]="1 + i" [name]="'quest' + i"
                                        [ngClass]="{'error-input-border': question.invalid}"
                                        [placeholder]="question.questioN_TEXT" [(ngModel)]="question.response"
                                        maxlength="4000">
                                </div>
                                <div *ngIf="['MULTIPLE_CHOICE', 'YES_NO'].includes(question.questioN_TYPE)"
                                    class="flex flex-col gap-2">
                                    <mat-select [id]="'questionFormQuest' + i" [(ngModel)]="question.response"
                                        [name]="'quest' + i" class="borde p-3 w-full"
                                        [tabIndex]="1 + i"
                                        [ngClass]="{'error-input-border': question.invalid}" (focus)="onFocus($event)" (blur)="onBlur($event)" [placeholder]="question.questioN_TEXT">
                                        <mat-option *ngFor="let option of question.options; let i = index"
                                            [value]="option.optioN_ID">
                                            {{ option.optioN_TEXT | translate }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                                <div *ngIf="question.questioN_TYPE == 'CHECKBOXES'" class="flex flex-col gap-2">
                                    <mat-select [id]="'questionFormQuest' + i" [(ngModel)]="question.response"
                                        [name]="'quest' + i" class="borde p-3 w-full"
                                        [tabIndex]="1 + i"
                                        [ngClass]="{'error-input-border': question.invalid}" multiple
                                        (focus)="onFocus($event)" (blur)="onBlur($event)"
                                        (selectionChange)="onSelectionChange($event, question)" [placeholder]="question.questioN_TEXT">
                                        <mat-option *ngFor="let option of question.options; let i = index"
                                            [value]="option.optioN_ID"
                                            [disabled]="isOptionDisabled(question, option.optioN_ID)">
                                            {{ option.optioN_TEXT | translate }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-center md:justify-end">
            <div class="w-full px-4 md:px-0 md:w-auto">
                <app-custom-primary-button type="submit" color="primary" size="small" class="w-full md:w-auto"
                    [tabindex]="questionaire.questions.length + 1">
                    <span *ngIf="!sending">{{ "candidateCFSubmit" | translate }}</span>
                    <div *ngIf="sending" class="w-full flex justify-center">
                        <mat-spinner diameter="20" color="primary"></mat-spinner>
                    </div>
                </app-custom-primary-button>
            </div>
        </div>

    </form>
</div>

<div *ngIf="!isFormAlreadySubmitted && isTokenValid === false" class="flex flex-col items-center justify-center min-h-screen">
    <img [src]="haibuBroken" alt="Token not valid" class="w-1/3 md:w-1/4 max-w-xs mx-auto">
    <p class="mt-4 text-lg">{{ 'candidateCFTokenNotValid' | translate }}</p>
</div>

<div *ngIf="!isFormAlreadySubmitted && isTokenValid === null" class="flex flex-col items-center justify-center min-h-screen">
    <img [src]="haibuLoading" alt="Loading..." class="w-1/3 md:w-1/4 max-w-xs mx-auto">
    <p class="mt-4 text-lg">{{ 'candidateExternalValidatingToken' | translate }}</p>
</div>

<div *ngIf="isFormAlreadySubmitted" class="flex flex-col items-center justify-center min-h-screen">
    <img [src]="haibuCheck" alt="Submission confirmed" class="w-1/3 md:w-1/4 max-w-xs mx-auto">
    <div class="mt-4 px-4 md:px-20 lg:px-32 xl:px-48">
        <p class="text-lg text-center"
            [innerHTML]="'candidateCFSubmited' | translate"></p>
    </div>
</div>